// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"226":"1feca243","277":"3eb1fa39","453":"a775a65d","506":"2eb7ac3a","553":"e7ef908d","647":"5c4556e2","914":"19470d18","977":"b62bfdf9"}[chunkId] + ".chunk.js";
};